<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="68" rx="0" ry="0" width="345" height="98" />
        <rect x="16" y="218" rx="0" ry="0" width="108" height="81" />
        <rect x="136" y="220" rx="0" ry="0" width="223" height="29" />
        <rect x="137" y="257" rx="0" ry="0" width="129" height="20" />
        <rect x="137" y="282" rx="0" ry="0" width="52" height="19" />
        <rect x="15" y="15" rx="0" ry="0" width="345" height="36" />
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <rect x="17" y="310" rx="0" ry="0" width="108" height="81" />
        <rect x="136" y="311" rx="0" ry="0" width="223" height="29" />
        <rect x="137" y="348" rx="0" ry="0" width="129" height="20" />
        <rect x="137" y="373" rx="0" ry="0" width="52" height="19" />
        <rect x="18" y="402" rx="0" ry="0" width="108" height="81" />
        <rect x="137" y="404" rx="0" ry="0" width="223" height="29" />
        <rect x="138" y="441" rx="0" ry="0" width="129" height="20" />
        <rect x="138" y="466" rx="0" ry="0" width="52" height="19" />
        <rect x="15" y="184" rx="0" ry="0" width="103" height="25" />
        <rect x="15" y="504" rx="0" ry="0" width="115" height="25" />
        <rect x="16" y="541" rx="0" ry="0" width="192" height="120" />
        <rect x="221" y="541" rx="0" ry="0" width="192" height="120" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/videoListSkeleton.vue